export const SET_LOADING = 'SET_LOADING'

export default {
  SET_LOADING
}
